import { Popover } from 'antd'
import React, { useRef, useState } from 'react'

import styles from './index.less'

export default ({ openLoginModal }: any) => {
  const [visible, setVisible] = useState(false)
  const popRef = useRef(null)
  const popContent = () => {
    return (
      <div className={styles.popContent}>
        <div className={styles.member}>
          <img src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/anniu_huiyuan.png" alt="" />
          WIME会员
        </div>
        <div className={styles.content}>
          <h1>Al商业图片快速生成</h1>
          <h2>专业商拍图、质感商详长图、精美商品主图智能快速生成</h2>
        </div>
        <div className={styles.content}>
          <h1>AI爆款内容轻松创作</h1>
          <h2>小红书种草文案、朋友圈/社群推广文案等多渠道爆款内容轻松创作</h2>
        </div>
        <div className={styles.content}>
          <h1>海量模板免费使用</h1>
          <h2>海量电商场景精选模板免费使用不限量</h2>
        </div>
        <button
          className={styles.open}
          onClick={() => {
            setVisible(false)
            openLoginModal()
          }}
        >
          低至¥9.9，立即体验
        </button>
      </div>
    )
  }

  return (
    <Popover
      placement="bottomRight"
      overlayClassName={styles.pop}
      arrow={false}
      content={popContent}
      open={visible}
      onOpenChange={setVisible}
      // color={'rgba(0, 0, 0, 0.75)'}
      ref={popRef}
    >
              <div
                className={styles.popUserDiv}
              >
                <img
                  className={styles.img}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/99kaitonghuiyuan@3x.png"
                  alt=""
                />
                <img
                  className={styles.hoverImg}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/99kaitonghuiyuan-hover2@3x.png"
                  alt=""
                />
              </div>
    </Popover>
  )
}
